
const $c8465e7108916662$export$15ccffc5e5392538 = function() {
    const scale = 100;
    let ts = -1;
    let T = null;
    const checkPosition = function() {
        const hh = document.querySelector("header.header").scrollHeight;
        const vh = document.documentElement.clientHeight;
        if (!(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug || !document.querySelector(`[id='${(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug}'].__js_stats_wrapper`)) return;
        const article = document.querySelector(`[id='${(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug}'].__js_stats_wrapper`);
        const tt = article.getBoundingClientRect().top;
        const r = (article.scrollHeight + hh) / scale; // ratio
        // Jeżeli nie ma tablicy flag dla tego obiektu to utwórz
        if (T == null) {
            T = {
                consumed: {},
                flags: []
            };
            // inicjacja tablic flag dla kolejnych części
            // eslint-disable-next-line no-plusplus
            for(let k = 1; k <= scale; k++){
                T.flags[k] = {};
                T.flags[k].begin = 0;
                T.flags[k].end = 0;
            }
        }
        // eslint-disable-next-line no-plusplus
        for(let l = 1; l <= scale; l++){
            if (!T.flags[l].begin && tt < -(l - 1) * r + vh + hh && tt >= -(l - 1) * r) T.flags[l].begin = 1;
            if (!T.flags[l].end && tt <= -l * r + vh + hh && tt > -l * r) T.flags[l].end = 1;
        }
        // eslint-disable-next-line no-plusplus
        for(let m = 1; m <= scale; m++)if (!T.consumed[m] && T.flags[m].begin && T.flags[m].end) // staty dla setnych
        T.consumed[m] = 1;
    };
    const getValue = function() {
        if (!T) return 0;
        const prc = Object.keys(T.consumed).length;
        T = null; // resetowanie tablicy przy odczycie
        return prc;
    };
    window.addEventListener("load", ()=>{
        ts = setInterval(checkPosition, 100);
    });
    return {
        burp: getValue,
        debug () {
            return T && T.consumed ? Object.keys(T.consumed).length : "-";
        }
    };
}();


class $09a1f2fdb75e0e39$var$Scrollytelling {
    _load() {
        let idTS;
        window.addEventListener("scroll", ()=>{
            this.isScrollingController(true);
            if (idTS) clearTimeout(idTS);
            idTS = setTimeout(()=>{
                idTS = null;
                this.isScrollingController(false);
            }, 50);
        });
    }
    getScrollingState() {
        return this.isScrollingFlag;
    }
    isScrollingController(state) {
        this.isScrollingFlag = state;
    }
    unloadData() {
        // console.log('this', this);
        const ac = document.querySelector("article").getAttribute("data-id");
        if (this.indT.length === 4) this.scroll100Indicator = 1;
        else this.scroll100Indicator = 0;
        const statElementArray = [];
        const { scroll100Indicator: scroll100Indicator } = this;
        for(const pos in this.statElementCollector)statElementArray.push(this.statElementCollector[pos]);
        const cScrollPercentValue = (0, $c8465e7108916662$export$15ccffc5e5392538).burp() || 0;
        try {
            WP.pwp.closePage({
                ga: {
                    event: "unload",
                    page: {
                        sliderConsumption: statElementArray,
                        content: {
                            section: {
                                scroll100Indicator: scroll100Indicator
                            }
                        },
                        ac: ac,
                        templateType: "AS"
                    },
                    content: {
                        pageViewCount: 1,
                        scrollPercent: "",
                        cScrollPercent: cScrollPercentValue,
                        cS: cScrollPercentValue
                    }
                }
            });
        // console.log(dataLayer);
        } catch (error) {
            console.error("b\u0142\u0105d wpjslib: ", error);
        }
    }
    constructor(){
        this.isScrollingFlag = false;
        this.scroll100Indicator = 0;
        this.statElementCollector = {};
        this.slidePositionVieved = {};
        this.lastReportedSlug = null;
        this.indT = [];
        this._load();
    }
}
const $09a1f2fdb75e0e39$export$f50add2b9bf338bd = new $09a1f2fdb75e0e39$var$Scrollytelling();



function $ef1aca95387f353c$export$59068a9e2ba3b302(category, action, label, value) {
    if (value) // gtag('gtag_event', `${action}-${value}`, {
    //   event_category: category,
    //   event_label: label,
    // });
    try {
        WP.stat.show(wp_sn, {
            category: category,
            label: label,
            value: value,
            asproduct: asproduct,
            asorderid: asorderid,
            asname: asname
        }, action);
    } catch (e) {
        console.log(`stat.show ERROR: ${e}`);
    }
    else // gtag('gtag_event', action, {
    //   event_category: category,
    //   event_label: label,
    // });
    try {
        WP.stat.show(wp_sn, {
            category: category,
            label: label,
            asproduct: asproduct,
            asorderid: asorderid,
            asname: asname
        }, action);
    } catch (e) {
        console.log(`stat.show ERROR: ${e}`);
    }
}
function $ef1aca95387f353c$export$b787208c1ce0d1ab() {
    document.querySelectorAll("[data-ga360-click]").forEach((el)=>{
        const clickEvent = function(ev) {
            el.addEventListener(ev, function() {
                const eventCategory = this.getAttribute("data-ga360-click");
                const eventAction = "ontouchstart" in document.documentElement ? "tap" : "click";
                let eventLabel;
                if (this.closest(".header")) eventLabel = "header";
                else if (this.closest(".footer")) eventLabel = "footer";
                else eventLabel = window.location.href;
                WP.push(()=>{
                    WP.pwp.customAction({
                        ga: {
                            event: "site_interaction",
                            eventCategory: eventCategory,
                            eventAction: eventAction,
                            eventLabel: eventLabel
                        }
                    });
                });
                $ef1aca95387f353c$export$59068a9e2ba3b302(eventCategory, eventAction, eventLabel);
            });
        };
        clickEvent("click");
        clickEvent("auxclick");
        clickEvent("contextmenu");
    });
}
function $ef1aca95387f353c$export$59023bf76483558d() {
    document.querySelectorAll(".__js_socialShare").forEach((el)=>{
        el.addEventListener("click", function(e) {
            e.preventDefault();
            const eventCategory = this.getAttribute("data-id");
            const href = this.getAttribute("data-href");
            const eventAction = "ontouchstart" in document.documentElement ? "tap" : "click";
            let ga360Socials;
            const eventLabel = window.location.href;
            if (eventCategory === "facebook") {
                window.open(href, "_blank", "top=100, left=300, width=320,height=320,toolbar=1,resizable=0");
                ga360Socials = "share_FB";
            }
            if (eventCategory === "instagram") {
                window.open(href, "_blank", "top=100, left=300, width=320,height=320,toolbar=1,resizable=0");
                ga360Socials = "share_Instagram";
            }
            if (eventCategory === "twitter") {
                window.open(href, "_blank", "top=100, left=300, width=320,height=320,toolbar=1,resizable=0");
                ga360Socials = "share_Twitter";
            }
            if (eventCategory === "linkedin") {
                window.open(href, "_blank", "top=100, left=300, width=320,height=320,toolbar=1,resizable=0");
                ga360Socials = "share_Linkedin";
            }
            WP.push(()=>{
                WP.pwp.customAction({
                    ga: {
                        event: "site_interaction",
                        eventCategory: ga360Socials,
                        eventAction: eventAction,
                        eventLabel: eventLabel
                    }
                });
            });
            $ef1aca95387f353c$export$59068a9e2ba3b302(eventCategory, eventAction, eventLabel);
        });
    });
}
function $ef1aca95387f353c$export$6af9dd71d09bb284() {
    document.querySelectorAll("[data-ga360-id]").forEach(function(el) {
        const artId = el.closest("article").getAttribute("data-id");
        const ga360id = el.getAttribute("data-ga360-id");
        if (ga360id === undefined) console.log(`%c doda\u{107} ga360-id do Galerii hover: ${this.getAttribute("data-id")}`, "background: #553311; padding: 3px; color: #ffaaaa");
        else (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).statElementCollector[`${ga360id}-${artId}`] = {
            id: ga360id,
            moduleName: el.getAttribute("data-id"),
            viewedCount: 0,
            itemCount: el.querySelectorAll(".widget__item").length
        };
        el.statVievedSlide = [];
        (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).slidePositionVieved[`${ga360id}-${artId}`] = {};
    });
} // export function statsOnWidgetInteraction(item, arg, idx, evType) {
 //   const artId = item.closest('article').getAttribute('data-id');
 //   const ga360id = item.closest('[data-ga360-id]').getAttribute('data-ga360-id');
 //   const dataId = item.closest('[data-id]').getAttribute('data-id');
 //   const isClick = !!item.closest('.gallery-slider');
 //   const hoverEventType = 'ontouchstart' in document.documentElement ? 'tap' : 'hover';
 //
 //   const itemId = arg;
 //   if (!ga360id) {
 //     console.log(
 //       `%c dodać ga360-id do ${dataId}background: #3b3b3b; padding: 3px; color: #beeb2f`,
 //     );
 //   }
 //   const index = idx || getIndex(item);
 //
 //   if (!scrollytelling.isScrollingFlag) {
 //     scrollytelling.slidePositionVieved[`${ga360id}-${artId}`][index] = 1;
 //     scrollytelling.statElementCollector[`${ga360id}-${artId}`].viewedCount = Object.keys(scrollytelling.slidePositionVieved[`${ga360id}-${artId}`]).length;
 //     sendStats(
 //       'gallery',
 //       `${isClick && evType ? evType : hoverEventType}-${index}`,
 //       `${artId} / ${dataId}`,
 //       itemId,
 //     );
 //     WP.pwp.customAction({
 //       ga: {
 //         event: 'content_interaction',
 //         eventCategory: ga360id,
 //         moduleName: dataId,
 //         eventAction: isClick && evType ? evType : hoverEventType,
 //       },
 //     });
 //   }
 // }



function $a248544641396ff8$export$c4afaad3e1e578ec() {
    const scale = 4; // dokładność w 1/scale  dla 4 będzie 25% czyli ćwiartki
    let sTS = -1;
    const T = [];
    const checkPosition = function() {
        const hh = document.querySelector("header.header").scrollHeight; // header height
        const vh = document.documentElement.clientHeight; // viewport height
        const articles = document.querySelectorAll("article");
        Array.prototype.forEach.call(articles, (e, n)=>{
            const tt = parseInt(e.getBoundingClientRect().top, 10);
            const bt = parseInt(e.getBoundingClientRect().bottom, 10);
            const g = parseInt(vh - tt - hh, 10); // góra artykułu w viewport
            const d = parseInt(bt - hh, 10); // dół artykułu w viewport
            const r = parseInt((e.scrollHeight + hh) / scale, 10); // ratio
            const statId = e.getAttribute("data-id");
            // Jeżeli nie ma jeszcze tablicy flag to ją utwórz
            if (typeof T[n] === "undefined") {
                T[n] = [];
                // inicjacja tablic flag dla kolejnych ćwiartek
                // eslint-disable-next-line no-plusplus
                for(let k = 1; k <= scale; k++){
                    T[n][k] = {};
                    T[n][k].begin = 0;
                    T[n][k].end = 0;
                    T[n][k].send = 0;
                }
            }
            // czy artykuł jest w vieportcie
            if (g > 0 && d > 0) {
                if (typeof T[n][0] === "undefined") {
                    T[n][0] = 1;
                    // PageViews
                    // console.log('view', 'scroll', statId);
                    (0, $ef1aca95387f353c$export$59068a9e2ba3b302)("view", "scroll", statId);
                }
            }
            // eslint-disable-next-line no-plusplus
            for(let l = 1; l <= scale; l++){
                if (!T[n][l].begin && tt < -(l - 1) * r + vh + hh && tt > -(l - 1) * r) T[n][l].begin = 1;
                if (!T[n][l].end && tt < -l * r + vh + hh && tt > -l * r) T[n][l].end = 1;
            }
            // eslint-disable-next-line no-plusplus
            for(let m = 1; m <= scale; m++)if (!T[n][m].send && T[n][m].begin && T[n][m].end) {
                (0, $ef1aca95387f353c$export$59068a9e2ba3b302)("progress", "scroll", statId, m * (100 / scale));
                // console.log('progress', 'scroll', statId, m * (100 / scale));
                // staty dla ćwiartek
                T[n][m].send = 1;
                (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).indT.push(n);
            }
        });
    };
    window.addEventListener("load", ()=>{
        if (sTS > 0) clearTimeout(sTS);
        sTS = setTimeout(checkPosition, 750);
    });
    window.addEventListener("scroll", ()=>{
        if (sTS > 0) clearTimeout(sTS);
        sTS = setTimeout(checkPosition, 50);
    });
}


function $83fe3237aad9f51d$export$6e196edbcc00e5bc() {
    const animatedElements = document.querySelectorAll("._js_inViewport, .__js_preload, .section-fixed, .section-wideo");
    const obsCallback = function(entries, observer) {
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                if (entry.target.classList.contains("_js_inViewport")) entry.target.classList.add("__js_onScreen");
                if (entry.target.classList.contains("__js_preload")) {
                    const srcS = entry.target.getAttribute("data-src");
                    entry.target.style.opacity = "0.3";
                    entry.target.setAttribute("src", srcS);
                    entry.target.style.opacity = "1";
                    entry.target.classList.remove("__js_preload");
                    observer.unobserve(entry.target);
                }
                if (entry.target.classList.contains("section-fixed")) entry.target.querySelector(".img-fixed-bg").classList.add("fullpage-fixed");
                if (entry.target.classList.contains("section-wideo")) entry.target.querySelector(".article__wideo").classList.add("wideo-fixed");
            } else {
                if (entry.target.classList.contains("_js_inViewport") && entry.target.classList.contains("__js_onScreen")) // entry.target.classList.remove('__js_onScreen');
                observer.unobserve(entry.target);
                if (entry.target.classList.contains("section-fixed")) entry.target.querySelector(".img-fixed-bg").classList.remove("fullpage-fixed");
                if (entry.target.classList.contains("section-wideo")) entry.target.querySelector(".article__wideo").classList.remove("wideo-fixed");
            }
        });
    };
    const windowH = `${(window.innerHeight - 100) * -1}px`;
    const observer = new IntersectionObserver(obsCallback, {
        root: null,
        threshold: 0
    });
    animatedElements.forEach((elem)=>{
        observer.observe(elem);
    });
}




const $f10bcbe3ede63498$export$fff6713f4218d9cf = ()=>{
    document.querySelectorAll(".player").forEach((el, i)=>{
        el.setAttribute("id", `player_${i}`);
        const url = el.getAttribute("data-url");
        WP.push(()=>{
            let playerInitialized = false;
            const statsQuadrantsPos = {};
            let clipName;
            let clipMid;
            const player = new WP.player({
                url: url,
                target: `player_${i}`,
                adv: false,
                hiderelated: true,
                extendedrelated: false,
                floatingplayer: false,
                autoplay: true,
                forceliteembed: false
            });
            const statsQuadrants = (p)=>{
                p = Math.round(p * 100);
                if (!statsQuadrantsPos[clipMid]) statsQuadrantsPos[clipMid] = {};
                if (p >= 25 && p < 50) {
                    if (!statsQuadrantsPos[clipMid][25]) {
                        statsQuadrantsPos[clipMid][25] = 1;
                        (0, $ef1aca95387f353c$export$59068a9e2ba3b302)("video", "quarter=25", clipName);
                    }
                } else if (p >= 50 && p < 75) {
                    if (!statsQuadrantsPos[clipMid][50]) {
                        statsQuadrantsPos[clipMid][50] = 1;
                        (0, $ef1aca95387f353c$export$59068a9e2ba3b302)("video", "quarter=50", clipName);
                    }
                } else if (p >= 75 && p < 100) {
                    if (!statsQuadrantsPos[clipMid][75]) {
                        statsQuadrantsPos[clipMid][75] = 1;
                        (0, $ef1aca95387f353c$export$59068a9e2ba3b302)("video", "quarter=75", clipName);
                    }
                }
            };
            player.on("INIT", ()=>{
                if (!playerInitialized) {
                    playerInitialized = true;
                    player.setVolume(0.5);
                }
            });
            player.on("START_MOVIE", ()=>{
                clipName = player.getClipData().title;
                clipMid = player.getClipData().mid;
                (0, $ef1aca95387f353c$export$59068a9e2ba3b302)("video", "view", clipName);
            });
            player.on("END_MOVIE", ()=>{
                (0, $ef1aca95387f353c$export$59068a9e2ba3b302)("video", "end", clipName);
            });
            player.on("UPDATE_POSITION", (e)=>{
                const position = player.getPosition();
                statsQuadrants(position);
            });
        });
    });
};


const $0f54a0ec3fed16fd$export$b1e5508a851be14d = ()=>{
    if (document.querySelector(".header--hamburger")) {
        const hamburger = document.querySelector(".header--hamburger");
        const nav = document.querySelector(".header--nav");
        for(let i = 0; i < 4; i++){
            const span = document.createElement("span");
            hamburger.appendChild(span);
        }
        hamburger.addEventListener("click", ()=>{
            hamburger.classList.toggle("__js_isActive");
            nav.classList.toggle("__js_isActive");
        });
        nav.querySelector("ul").addEventListener("click", ()=>{
            nav.classList.remove("__js_isActive");
            hamburger.classList.remove("__js_isActive");
        });
        document.querySelector(".header").addEventListener("mouseleave", ()=>{
            nav.classList.remove("__js_isActive");
            hamburger.classList.remove("__js_isActive");
        });
    }
};




const $4fc2ea60f51b2fc8$export$7faf886a3af7f43d = (offset, callback)=>{
    const fixedOffset = offset.toFixed();
    const onScroll = function() {
        if (window.scrollY.toFixed() === fixedOffset) {
            window.removeEventListener("scroll", onScroll);
            callback();
        }
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    window.scrollTo({
        top: offset,
        behavior: "smooth"
    });
};
const $4fc2ea60f51b2fc8$export$61fc7d43ac8f84b0 = (func, delay = 1000)=>{
    let timeoutId;
    return (...args)=>{
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            func(...args);
        }, delay);
    };
};
const $4fc2ea60f51b2fc8$export$ddfa24987dade61b = (item)=>{
    const nodes = Array.prototype.slice.call(item.parentElement.children);
    return nodes.indexOf(item);
};
const $4fc2ea60f51b2fc8$export$fefb0b708318327a = function(input) {
    const characterCounter = document.createElement("div");
    characterCounter.classList.add("character-counter");
    characterCounter.innerText = `0 / ${input.getAttribute("maxlength")}`;
    input.closest("fieldset").append(characterCounter);
    input.addEventListener("input", function() {
        characterCounter.innerText = `${this.value.length} / ${this.getAttribute("maxlength")}`;
    });
};
const $4fc2ea60f51b2fc8$export$edb889f0799652d1 = (el, operation)=>{
    if (operation === "add") {
        el.closest("fieldset").classList.add("has-error");
        el.closest("fieldset").setAttribute("data-error", "To pole jest obowi\u0105zkowe, aby wzi\u0105\u0107 udzia\u0142 w konkursie");
    } else if (operation === "remove") {
        el.closest("fieldset").classList.remove("has-error");
        el.closest("fieldset").setAttribute("data-error", "");
    }
};
const $4fc2ea60f51b2fc8$export$bd454f0cef11418d = (el, char)=>{
    const isValid = el.value.trim().length > char;
    if (!isValid) $4fc2ea60f51b2fc8$export$edb889f0799652d1(el, "add");
    else $4fc2ea60f51b2fc8$export$edb889f0799652d1(el, "remove");
    return isValid;
};
const $4fc2ea60f51b2fc8$export$3e31809f83ca08ca = (el)=>{
    if (!el.checked) $4fc2ea60f51b2fc8$export$edb889f0799652d1(el, "add");
    else $4fc2ea60f51b2fc8$export$edb889f0799652d1(el, "remove");
    return el.checked;
};
const $4fc2ea60f51b2fc8$export$64ddf344ab9330e3 = (emailAddress)=>{
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z\-0-9]{2,}))$/;
    return re.test(String(emailAddress).toLowerCase());
};
const $4fc2ea60f51b2fc8$export$18148d12c805c5b0 = (el)=>{
    const isValid = $4fc2ea60f51b2fc8$export$64ddf344ab9330e3(el.value);
    if (!isValid) $4fc2ea60f51b2fc8$export$edb889f0799652d1(el, "add");
    else $4fc2ea60f51b2fc8$export$edb889f0799652d1(el, "remove");
    return isValid;
};
const $4fc2ea60f51b2fc8$var$spinnerHtml = `<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
   <circle class="path" fill="none" stroke-width="3" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
</svg>`;
const $4fc2ea60f51b2fc8$export$2342b8d835c798ac = (formEl, opacity)=>{
    formEl.querySelectorAll("input, textarea, button").forEach((input)=>{
        input.setAttribute("disabled", "");
    });
    if (opacity) formEl.classList.add("form-opacity");
    const spinnerWrapper = document.createElement("div");
    spinnerWrapper.classList.add("spinner-wrapper");
    spinnerWrapper.innerHTML = $4fc2ea60f51b2fc8$var$spinnerHtml;
    formEl.append(spinnerWrapper);
};


const $1dbbb908c57973f8$export$9a3fa8cafe091d3d = function() {
    const initSlug = document.location.pathname.split("/").pop() || document.querySelectorAll(".__js_stats_wrapper")[0].getAttribute("id");
    (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug = initSlug;
    const customOffset = document.querySelector(".header").getBoundingClientRect().height;
    // const customOffset = parseInt(getComputedStyle(document.documentElement)
    //   .getPropertyValue('--header-height'));
    const sections = document.querySelectorAll(".__js_stats_wrapper");
    let wp_content_selector;
    const animationTime = 800;
    let sectionScrollCheckTS = null;
    let reportSlugTS = -1;
    const reportSlug = function() {
        if ((0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).lastReportedSlug === null) {
            // wyślij statystykę pageview standard
            // console.log('statData[scrollytelling.activeSlug]', statData);
            wp_dot_addparams.ctags = statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].tags;
            WP.push(()=>{
                WP.pwp.viewPage({
                    ga: {
                        event: "pageview",
                        page: {
                            pageviewType: "standard",
                            error404: basicStatData.ga.page.error404,
                            templateType: "AS"
                        },
                        site: {
                            name: basicStatData.ga.site.name,
                            version: basicStatData.ga.site.version,
                            cms: basicStatData.ga.site.cms,
                            as: {
                                orderId: asorderid,
                                productName: asproduct,
                                name: asname
                            }
                        },
                        content: {
                            title: statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].title,
                            category: {
                                IAB: statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].category.IAB,
                                Gemius: statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].category.Gemius
                            },
                            tags: statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].tags
                        }
                    }
                });
            });
        } else {
            // wyślij statystykę pageview scrolboost vpv. pageviewType ma wartość "overlay"
            // gdy nie mamy doładowania i "scrollboost" gdy następuje doładowanie, ALE dla pseudo dynamicznych stron AS ma byc jednak scrollboost ;) - ustalone z Salestube !
            wp_content_selector = document.getElementById((0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).lastReportedSlug);
            (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).unloadData((0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).lastReportedSlug);
            wp_dot_addparams.ctags = statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].tags;
            WP.push(()=>{
                WP.pwp.viewPage({
                    ga: {
                        event: "pageviewVpv",
                        page: {
                            pageviewType: "scrollboost",
                            error404: basicStatData.ga.page.error404,
                            templateType: "AS"
                        },
                        site: {
                            name: basicStatData.ga.site.name,
                            version: basicStatData.ga.site.version,
                            cms: basicStatData.ga.site.cms,
                            as: {
                                orderId: asorderid,
                                productName: asproduct,
                                name: asname
                            },
                            frontendPlatform: "other"
                        },
                        content: {
                            title: statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].title,
                            category: {
                                IAB: statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].category.IAB,
                                Gemius: statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].category.Gemius
                            },
                            tags: statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].tags
                        }
                    }
                });
            });
        }
        (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).lastReportedSlug = (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug;
        reportSlugTS = -1;
    };
    const changeActiveSlug = function(slug) {
        (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug = slug;
        document.querySelectorAll(".header--nav li a").forEach((el)=>el.classList.remove("__active"));
        document.querySelector(`.header--nav [data-slug="${slug}"]`).classList.add("__active");
        document.querySelector(".header--nav ul").setAttribute("class", `order_${(0, $4fc2ea60f51b2fc8$export$ddfa24987dade61b)(document.querySelector(`.header--nav [data-slug="${slug}"]`).closest("li"))}`);
        const dSN = slug === "intro" ? defaultSiteTitle : `- ${defaultSiteTitle}`;
        if (document.location.search.length > 0) {
            history.pushState({
                id: slug
            }, slug, slug + document.location.search);
            if (document.querySelector("title")) document.querySelector("title").innerText = `${statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].title} ${dSN}`;
            if (document.querySelector('meta[property="og:title"]')) document.querySelector('meta[property="og:title"]').content = `${statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].title} ${dSN}`;
            if (document.querySelector('meta[name="twitter:title"]')) document.querySelector('meta[name="twitter:title"]').content = `${statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].title} ${dSN}`;
        } else {
            history.pushState({
                id: slug
            }, slug, slug);
            if (document.querySelector("title")) document.querySelector("title").innerText = `${statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].title} ${dSN}`;
            if (document.querySelector('meta[property="og:title"]')) document.querySelector('meta[property="og:title"]').content = `${statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].title} ${dSN}`;
            if (document.querySelector('meta[name="twitter:title"]')) document.querySelector('meta[name="twitter:title"]').content = `${statData[(0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug].title} ${dSN}`;
        }
        if ((0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).lastReportedSlug === null) // jeżeli pierwsze wejście to wysyłaj pageview od razu
        reportSlug();
        else if ((0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).lastReportedSlug !== slug) {
            // jeżeli zmiana sluga to wysyłaj po sekundzie statystykę
            if (reportSlugTS > -1) clearTimeout(reportSlugTS);
            reportSlugTS = setTimeout(reportSlug, 1000);
        } else if (reportSlugTS > -1) clearTimeout(reportSlugTS);
    };
    /* Sprawdzanie czy user zescrollował do sekcji. Jeżeli tak to ustawia pozycję w nawigacji */ const sectionScrollCheck = function() {
        sectionScrollCheckTS = setTimeout(sectionScrollCheck, 200);
        const topScroll = document.querySelector("body").getBoundingClientRect().top === 0 ? 0 : -document.querySelector("body").getBoundingClientRect().top;
        // wymuszenie strony głównej
        if (topScroll <= customOffset && document.location.pathname.split("/").pop().length < 1) {
            changeActiveSlug(sections[0].getAttribute("id"));
            return;
        }
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            // const sectionOffset = section.getBoundingClientRect().top;
            const sectionOffset = section.offsetTop;
            const sectionHeight = section.getBoundingClientRect().height;
            // console.info(i, topScroll, sectionOffset, sectionOffset + sectionHeight);
            if ((0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).activeSlug !== section.getAttribute("id") && topScroll > sectionOffset - customOffset - 10 && topScroll < sectionOffset + sectionHeight - customOffset - 10) {
                // console.info(i, topScroll, sectionOffset, sectionOffset + sectionHeight);
                changeActiveSlug(section.getAttribute("id"));
                break;
            }
        }
    };
    /* Inicjalizacja metod dla obsługi nawigacji - clików i sprawdzanie scrolla */ const initNavigation = function() {
        sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25);
        document.querySelectorAll("[data-slug]").forEach((el)=>{
            el.addEventListener("click", (e)=>{
                // console.log('click');
                if (sectionScrollCheckTS) clearTimeout(sectionScrollCheckTS);
                e.preventDefault();
                let slug = el.getAttribute("data-slug");
                if (!slug.length) slug = "/";
                changeActiveSlug(slug);
                (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).isScrollingController(true);
                (0, $4fc2ea60f51b2fc8$export$7faf886a3af7f43d)(document.getElementById(slug).getBoundingClientRect().top + window.scrollY - customOffset, ()=>{
                    (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).isScrollingController(false);
                });
                // window.scrollTo({ top: document.getElementById(slug).getBoundingClientRect().top + window.scrollY - customOffset, behavior: 'smooth' });
                // document.getElementById(slug).scrollIntoView({
                //   behavior: 'smooth',
                // });
                sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25);
            });
        });
    };
    const scrollOnStart = function() {
        if (document.getElementById(initSlug)) {
            // document.getElementById(initSlug).scrollIntoView({
            //   behavior: 'smooth',
            // });
            (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).isScrollingController(true);
            (0, $4fc2ea60f51b2fc8$export$7faf886a3af7f43d)(document.getElementById(initSlug).getBoundingClientRect().top + window.scrollY - customOffset, ()=>{
                (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).isScrollingController(false);
            });
        // console.log('scroll');
        }
        (0, $ef1aca95387f353c$export$59068a9e2ba3b302)("progress", "start", initSlug);
        changeActiveSlug(initSlug);
        initNavigation();
    };
    // staty pageviews i scrollboost pwp ----- {
    if (initSlug.length > 1) setTimeout(scrollOnStart, 600);
};


//import { validateAndSubmitForm } from './validateAndSubmitForm';
//import { cssClasses } from './cssClasses';
//import { setMobileSrc } from './mobileSrc';
//import { debounce } from './helpers';
//setMobileSrc();
(0, $1dbbb908c57973f8$export$9a3fa8cafe091d3d)();
(0, $a248544641396ff8$export$c4afaad3e1e578ec)();
(0, $ef1aca95387f353c$export$6af9dd71d09bb284)();
(0, $ef1aca95387f353c$export$b787208c1ce0d1ab)();
(0, $83fe3237aad9f51d$export$6e196edbcc00e5bc)();
(0, $ef1aca95387f353c$export$59023bf76483558d)();
(0, $f10bcbe3ede63498$export$fff6713f4218d9cf)();
(0, $0f54a0ec3fed16fd$export$b1e5508a851be14d)();
//validateAndSubmitForm();
//cssClasses();
const $b54c0517cce068d5$var$changeSizesOnResize = ()=>{
    setMobileSrc();
};
//window.addEventListener('resize', debounce(changeSizesOnResize, 500));
window.addEventListener("beforeunload", (0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd).unloadData.bind((0, $09a1f2fdb75e0e39$export$f50add2b9bf338bd)));


//# sourceMappingURL=scripts.min.js.map
